import { render, staticRenderFns } from "./InventoryByReferenceTable.vue?vue&type=template&id=dac2d24e&"
import script from "./InventoryByReferenceTable.vue?vue&type=script&lang=js&"
export * from "./InventoryByReferenceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports